import { openDB } from 'idb';

const DB_NAME = 'compulse-offline-db';
const STORE_NAME = 'sync-queue';

export const triggerSyncStatusChange = () => {
  window.dispatchEvent(new Event('syncStatusChanged'));
};

export async function getPendingSyncCount() {
  const db = await getDB();
  const tx = db.transaction(STORE_NAME, 'readonly');
  const store = tx.objectStore(STORE_NAME);
  return await store.count();
}

export async function getDB() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
      }
    },
  });
}

export async function queueRequest(url, method, body) {
  const db = await getDB();
  await db.add(STORE_NAME, {
    url,
    method,
    body,
    timestamp: Date.now()
  });
  console.log(`[SyncManager] Request queued for ${url}`);
  triggerSyncStatusChange();
}

export async function flushQueue() {
  const db = await getDB();
  const tx = db.transaction(STORE_NAME, 'readonly');
  const store = tx.objectStore(STORE_NAME);
  const requests = await store.getAll();
  await tx.done;

  if (requests.length === 0) return;

  console.log(`[SyncManager] Flushing ${requests.length} queued requests...`);

  for (const req of requests) {
    try {
      const response = await fetch(req.url, {
        method: req.method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req.body)
      });
      if (response.ok) {
        const delTx = db.transaction(STORE_NAME, 'readwrite');
        await delTx.objectStore(STORE_NAME).delete(req.id);
        await delTx.done;
        triggerSyncStatusChange();
      }
    } catch (err) {
      console.error(`[SyncManager] Failed to sync request ${req.id}`, err);
    }
  }
}

// Automatically flush queue when online
window.addEventListener('online', () => {
  console.log('[SyncManager] Browser went online. Flushing queue...');
  flushQueue();
});
